module.exports = __webpack_public_path__ + "static/media/tag4.fe5f33ce.svg";